export const TOKEN = "HONOURWORLD_WEBSITE";
export const TOKEN_TEMP = "HONOURWORLD_TEMP_WEBSITE";
export const TOKEN_TEMP_AUTH = "HONOURWORLD_TEMP_AUTH_WEBSITE";

export const LOGOUT = "LOGOUT";
export const LOGOUT_LOADING = "LOGOUT_LOADING";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";
export const GET_USER = "GET_USER";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const GET_USER_LOADING = "GET_USER_LOADING";

// Data
export const GET_DATA = "GET_DATA";
export const GET_DATA_FAIL = "GET_DATA_FAIL";
export const GET_DATA_LOADING = "GET_DATA_LOADING";
export const UPDATE_DATA = "UPDATE_DATA";
export const ADD_DATA = "ADD_DATA";
export const ADD_DATA_FAIL = "ADD_DATA_FAIL";
export const DELETE_DATA = "DELETE_DATA";

// Airtime
export const GET_AIRTIME = "GET_AIRTIME";
export const UPDATE_AIRTIME = "UPDATE_AIRTIME";
export const ADD_AIRTIME = "ADD_AIRTIME";
export const DELETE_AIRTIME = "DELETE_AIRTIME";
export const GET_AIRTIME_FAIL = "GET_AIRTIME_FAIL";
export const GET_AIRTIME_LOADING = "GET_AIRTIME_LOADING";
export const ADD_AIRTIME_FAIL = "ADD_AIRTIME_FAIL";

// Electricity
export const GET_ELECTRICITY = "GET_ELECTRICITY";
export const UPDATE_ELECTRICITY = "UPDATE_ELECTRICITY";
export const ADD_ELECTRICITY = "ADD_ELECTRICITY";
export const DELETE_ELECTRICITY = "DELETE_ELECTRICITY";
export const GET_ELECTRICITY_FAIL = "GET_ELECTRICITY_FAIL";
export const GET_ELECTRICITY_LOADING = "GET_ELECTRICITY_LOADING";
export const ADD_ELECTRICITY_FAIL = "ADD_ELECTRICITY_FAIL";

export const GET_CABLE = "GET_CABLE";
export const UPDATE_CABLE = "UPDATE_CABLE";
export const ADD_CABLE = "ADD_CABLE";
export const DELETE_CABLE = "DELETE_CABLE";
export const GET_CABLE_FAIL = "GET_CABLE_FAIL";
export const GET_CABLE_LOADING = "GET_CABLE_LOADING";
export const ADD_CABLE_FAIL = "ADD_CABLE_FAIL";

export const GET_NETWORK = "GET_NETWORK";
export const GET_NETWORK_FAIL = "GET_NETWORK_FAIL";
export const GET_NETWORK_LOADING = "GET_NETWORK_LOADING";
export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_FAIL = "GET_PLANS_FAIL";
export const GET_PLANS_LOADING = "GET_PLANS_LOADING";

// ERRORS
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const GET_ERRORS_TEXT = "GET_ERRORS_TEXT";
